/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-15 17:18:35
 */

import * as Vue from "vue-tsx-support";
import {Component, Prop} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import Modal from "src/types/iview/Modal";
import Button from "src/types/iview/Button";
import {modalFactory} from "src/util/vueExtend";
import AuditLog from './auditLog';

export namespace AuditLogVOI {
	export interface PropsI {
        mn?: number
        name?: string
	}

}

@Component
class AuditLogModal extends Vue.Component<AuditLogVOI.PropsI> {
	@Prop({
		type: String
	})
    mn!: string
    
    @Prop({
		type: String
	})
	name!: string


	visible: boolean = false


	close () {
		this.closeModal()
	}

	closeModal() {
		this.visible = false
		this.$emit('close', false)
    }
    


	render (h) {
		return (
			<Modal
				title={'审核日志'}
                width="800"
                class-name="wqms-data-audit-modal"
				v-model={this.visible}
				mask-closable={false}
                on-on-cancel={this.close}
                footer-hide
			>
				<AuditLog mn={this.mn} name={this.name}></AuditLog>
				<div slot="footer">
				</div>
			</Modal>
		);
	}
}

export default function alertAuditLogModal (mn: string, name: string): Promise<boolean> {
		return new Promise((resolve, reject) => {
			modalFactory<AuditLogVOI.PropsI>(AuditLogModal)({
                mn,
                name
            })
            resolve()
		})
	}
